module.exports = __webpack_public_path__ + "static/img/BY-S07D.27f3694.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/vibrate/BY-S07D/BY-S07D.png
// module id = I3Gj
// module chunks = 0